export default __webpack_public_path__ + "static/media/getInspired.7314460c.png";